;$(function() {
	// function changeSubHeaderPosition() {
	// 	let container = $('.sub-header-container'),
	// 		subHeader = $('.sub-header'),
	// 		fixedHeader = $('.header__top_fixed');
	// 	if (($(window).scrollTop() > container.offset().top + subHeader.outerHeight())) {
	// 		container.height(subHeader.outerHeight());
	// 		subHeader.addClass('sub-header_fixed');
	// 		subHeader.addClass('shadow');
	// 		if (fixedHeader.length) {
	// 			subHeader.css('top', fixedHeader.outerHeight());
	// 			fixedHeader.removeClass('shadow');
	// 		}
	// 	} else {
	// 		container.height('');
	// 		subHeader.removeClass('sub-header_fixed');
	// 		subHeader.removeClass('shadow');
	// 		if (fixedHeader.length) {
	// 			fixedHeader.addClass('shadow');
	// 		}
	// 	}
	// }
    //
	// if ($('.sub-header').length) {
	// 	changeSubHeaderPosition();
	// 	$(window).scroll(changeSubHeaderPosition);
	// 	$(window).resize(changeSubHeaderPosition);
	// }
});